module.exports = __webpack_public_path__ + "static/media/left-arrow-orange-24x24.b7bc887b.svg";